export default {"src":"/_next/static/image/public/images/img_doc_bookmark.cbc898c6f9ee9037fa5440b88f105992.svg","height":149,"width":133};